var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(" "+_vm._s(_vm.fileID['status'])+" ")]),_c('v-card-actions',[_c('DeleteUpload',{attrs:{"fileID":_vm.fileID}}),_c('FileUpload',{attrs:{"fileID":_vm.fileID}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }